import React from 'react'
import { Form, Formik } from 'formik'
import Button from '../../../components/common/Button'
import Input from '../../../components/common/Input'
import { required } from '../../../utils/validators'

export default function UsersForm({ onCancel, onSubmit, initialValues, loading }) {
    return (
        <Formik onSubmit={onSubmit} initialValues={{ firstName: '', lastName: '', chatId: '', ...initialValues }}>
            <Form>
                <Input name="firstName" label="Исм" validate={required} />
                <Input name="lastName" label="Фамиля" validate={required} />
                <Input name="chatId" label="Телеграм ID" />
                <div className="is-pulled-right">
                    <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                    &nbsp;&nbsp;
                    <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                </div>
            </Form>
        </Formik>
    )
}
